"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CartInCartBannerBlock = void 0;
const base_component_1 = require("../../components/base-component");
const dom_1 = require("../../utils/dom");
const utils_1 = require("../../utils/utils");
const CART_PAGE_SELECTOR = 'cart-page';
class CartInCartBannerBlock extends base_component_1.BaseComponent {
    mountComponent() {
        const cart = (0, utils_1.$elParent)(CART_PAGE_SELECTOR, this);
        cart?.on('update-nodes', this.handleCartUpdate);
    }
    unmountComponent() {
        const cart = (0, utils_1.$elParent)(CART_PAGE_SELECTOR, this);
        cart?.off('update-nodes', this.handleCartUpdate);
    }
    handleCartUpdate = ({ node }) => {
        (0, dom_1.replaceNodeChildren)(this, (0, utils_1.$el)(`cart-in-cart-banner-block[block-id="${this.getAttribute('block-id')}"]`, node));
    };
}
exports.CartInCartBannerBlock = CartInCartBannerBlock;
